import axios from 'axios';
import './axiosInterceptor';
export const PASARELA = process.env.VUE_APP_URLPASARELA;
export const SolicitudCuenta = {
    // crear una solicitud de cuenta
    solicitar_cuenta(payload) {
        return  axios.post(PASARELA+"/administracion/solicitud-cuenta", payload)
    },
}
